import { FaLinkedin } from "react-icons/fa";

function Home() {
  const apps = [
    {
      name: "What's my IP?",
      url: "https://ip.soliman.nl",
      description: "Returns only your public IP address in plain text.",
      tech: "Backend: PHP, Frontend: None",
      privacy: "See general privacy notice below.",
    },
    {
      name: "Countdown clock [dev]",
      url: "https://countdown.soliman.nl",
      description: "Advanced countdown timer for events or whatever.",
      tech: "Backend: PHP (if you create a short link), Frontend: ReactJS",
      privacy:
        "See general privacy notice below. URL shortener stores text and settings of your countdown.",
    },
    {
      name: "QR code generator",
      url: "https://qr.soliman.nl",
      description: "Create QR codes for text, links, or other content.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
    {
      name: "QR code reader",
      url: "https://qr-reader.soliman.nl",
      description: "Scan and decode QR codes directly in your browser.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
    {
      name: "Markdown editor (with cheats)",
      url: "https://markdown.soliman.nl",
      description: "Edit and preview markdown with handy cheat sheet included.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
    {
      name: "Share secrets",
      url: "https://secret.soliman.nl",
      description: "Generate one-time links to share secrets safely.",
      tech: "Backend: PHP, Frontend: ReactJS",
      privacy:
        "See general privacy notice below. Secrets are stored encrypted and deleted after first access. Tip: Never include login links when sharing a secret.",
    },
    {
      name: "CSV manipulation tool [dev]",
      url: "https://csv.soliman.nl",
      description:
        "Paste or load CSV data, reorder columns by dragging and dropping, hide columns, change delimiter, modify the decimal sign, change date formats, add new columns and finally download or copy the updated CSV.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
    {
      name: "CSV validator [dev]",
      url: "https://csv-validator.soliman.nl",
      description: "Validate a CSV based on a YAML schema.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
    {
      name: "PDF + image binder [dev]",
      url: "https://binder.soliman.nl",
      description: "Combine PDFs and images into a single PDF with a coverpage and custom metadata.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
    {
      name: "PDF splitter [dev]",
      url: "https://pdfsplit.soliman.nl",
      description: "Split, reorder, and export pages from a PDF.",
      tech: "Frontend: ReactJS",
      privacy: "See general privacy notice below.",
    },
  ];

  return (
    <div>
      <header style={{ textAlign: "center", marginBottom: "1rem" }}>
        <div className="nintendo-box">
          <p>
            Welcome, I’m Marcel Soliman
            <a
              href="https://www.linkedin.com/in/marcelsoliman/"
              target="_blank"
              rel="noreferrer"
              style={{
                color: "#0A84FF", // LinkedIn blue
                textDecoration: "none",
                border: "none",
                boxShadow: "none",
                background: "transparent",
                padding: 0,
                margin: 0,
              }}
            >
              <FaLinkedin
                style={{ verticalAlign: "middle", marginLeft: "4px" }}
              />
            </a>
            . On this page I share personal tools I’ve developed with a focus on
            simplicity and privacy. No ads, no unnecessary clutter, and only a
            backend when absolutely necessary. Most of these tools are built as a
            React frontend-only app and run fully in your browser.  
            These are personal projects, evolving over time, and made available for anyone who finds them useful.
          </p>

          <hr
            style={{
              margin: "1.5rem 0",
              border: "none",
              borderTop: "2px solid #000",
            }}
          />

          {apps.map((app, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: "1.5rem",
                textAlign: "left",
                borderBottom: "1px dotted #999",
                paddingBottom: "1rem",
              }}
            >
              <a
                href={app.url}
                target="_blank"
                rel="noreferrer"
              >
                {app.name}
              </a>

              <p style={{ margin: "0.3rem 0 0.3rem 1rem" }}>{app.description}</p>
              <small style={{ display: "block", marginLeft: "1rem", color: "#fff" }}>
                <strong>Technologies:</strong> {app.tech}
              </small>
              <small style={{ display: "block", marginLeft: "1rem", color: "#fff" }}>
                <strong>Privacy:</strong> {app.privacy}
              </small>
            </div>
          ))}

          <br />
          <br />
          <a
            href="https://donate.stripe.com/bIY28Y1pZ61z5Us6oo"
            target="_blank"
            rel="noreferrer"
            className="donate"
          >
            Enjoying these tools? Buy me a coffee!
          </a>

          <hr
            style={{
              margin: "2rem 0 1rem",
              border: "none",
              borderTop: "2px solid #000",
            }}
          />

          <p style={{ fontSize: "1rem", color: "#fff", textAlign: "left" }}>
            <strong>Privacy notice:</strong> There are no cookies or tracking
            scripts on this site. My hosting provider keeps both access logs
            (IP, timestamp, browser, referrer) and error logs. My hosting
            provider anonymizes your IP after 7 days. A simple counter is
            incremented on each visit. Errors in scripts are logged without your
            data or anything that identifies you.
          </p>
          <div
            style={{
              all: "unset",            // reset all inherited styles
              display: "block",        // restore basic block behavior
            }}
          >
            <div
              style={{
                marginTop: "2rem",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a
                  href="https://themarkup.org/blacklight?url=soliman.nl"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Privacy Scan: Blacklight"
                  style={{ all: "unset", cursor: "pointer" }}
                >
                  <img
                    src="https://img.shields.io/badge/Privacy%20Scan-Blacklight-brightgreen"
                    alt="Privacy Scan"
                    style={{ display: "block" }}
                  />
                </a>

                <a
                  href="https://developer.mozilla.org/en-US/observatory/analyze?host=soliman.nl"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Security Scan: Mozilla Observatory"
                  style={{ all: "unset", cursor: "pointer" }}
                >
                  <img
                    src="https://img.shields.io/badge/Security%20Scan-Mozilla%20Observatory-brightgreen"
                    alt="Security Scan"
                    style={{ display: "block" }}
                  />
                </a>
                <a
                  href="https://developer.mozilla.org/en-US/observatory/analyze?host=soliman.nl"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Cookie Scan"
                  style={{ all: "unset", cursor: "pointer" }}
                >
                  <img
                    src="https://img.shields.io/badge/Cookies-None-brightgreen"
                    alt="No Cookies Badge"
                    style={{ display: "block" }}
                  />
                </a>
              </div>
            </div>
          </div>

        </div>
      </header>
    </div>
  );
}

export default Home;
